import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import FAQSection from './components/FAQSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <IndexSection />
        <FeaturesSection />
        <UpdatesSection />
        <ContactSection />
        <AppSection />
        <AboutSection />
        <FAQSection />
        <CommentsSection />
        <CardsSection />
        <TopicsSection />
        <MediaSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}